import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { GetReportsByCategoryAndProducer } from '../../../api/reports';
import { useQuery } from '@tanstack/react-query';

const urlParams = new URLSearchParams(window.location.search);

function ReportSelection(props) {
  const [reportID, setReportID] = useState(urlParams.get('reportID') ?? '');
  const [reports, setReports] = useState([]);
  const getReports = useQuery({
    queryKey: ['getReports', props.categoryID],
    queryFn: () => GetReportsByCategoryAndProducer({ UserID: 0, CategoryID: props.categoryID })(),
    enabled: props.categoryID !== undefined,
  });

  useEffect(() => {
    if (getReports.isSuccess && getReports.data) {
      const parsedData = JSON.parse(getReports.data);
      setReports(parsedData);

      if (reportID != null) {
        handleReportChange(reportID, parsedData);
      }
    }
  }, [getReports.isSuccess, getReports.data]);
  //console.log(reports, "reports");
  /*const getReports = () => {
    const body = {
      CategoryID: props.categoryID,
    };
    const options = {
      crossDomain: true,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    };

    fetch('/Reports/getReportsByCategoryAndProducer', options)
      .then((res) => res.json())
      .then((data) => {
        const parsedData = JSON.parse(data);

        setReports(parsedData);
        setLoading(false);

        if (reportID != null) {
          handleReportChange(reportID, parsedData);
        }
      });
  };*/

  const handleReportChange = (val, rpts) => {
    const itm = rpts.filter((i) => i.ReportID == val);
    if (!itm.length) return;
    props.setReport(
      itm[0].ReportPath,
      itm[0].ReportServerID,
      itm[0].ReportID,
      itm[0].ReportDescription,
      itm[0].Params,
      itm[0].PowerBIDatasetID,
      itm[0].PowerBIGroupID,
      itm[0].PowerBIReportID,
      itm[0].PowerBIWorkspaceID
    );
  };

  /* useEffect(() => {
    if (props.categoryID !== undefined) {
      getReports();
    }
  }, [props.categoryID]);*/

  return (
    <div id="report-select">
      <FormControl fullWidth>
        <InputLabel>Reports</InputLabel>
        <Select
          id="category-select"
          onChange={(event) => {
            handleReportChange(event.target.value, reports);
          }}
          disabled={getReports.isPending}
          defaultValue={reportID}
        >
          {getReports.isPending ? (
            <MenuItem>loading...</MenuItem>
          ) : reports !== null ? (
            reports.map((report) => (
              <MenuItem key={report.ReportID} value={report.ReportID}>
                {report.ReportName}
              </MenuItem>
            ))
          ) : (
            ''
          )}
        </Select>
      </FormControl>
    </div>
  );
}

export { ReportSelection };
